import mammoth from 'mammoth/mammoth.browser.js';
import TurndownService from 'turndown';
import { gfm } from 'turndown-plugin-gfm';
import DOMPurify from 'dompurify';
import { MAX_FILE_BYTES, MAX_CONTENT_BYTES, textBytes } from './limits.js';
const turndown = new TurndownService({ headingStyle: 'atx', codeBlockStyle: 'fenced', bulletListMarker: '-' });
turndown.use(gfm);
export async function importDocument(file) {
  if (file.size > MAX_FILE_BYTES) throw new Error('檔案超過 50 MB，請先縮小檔案');
  if (/\.doc$/i.test(file.name)) throw new Error('請先在 Word 將 .doc 另存為 .docx');
  let content, warnings = [];
  if (/\.docx$/i.test(file.name)) {
    const result = await mammoth.convertToHtml({ arrayBuffer: await file.arrayBuffer() }, { convertImage: mammoth.images.imgElement(async image => {
      if (!['image/png', 'image/jpeg', 'image/gif', 'image/webp'].includes(image.contentType)) { warnings.push('部分圖片格式未轉入，請查閱保留的 Word 原檔'); return { src: '', alt: '請查看 Word 原檔中的圖片' }; }
      return { src: 'data:' + image.contentType + ';base64,' + await image.read('base64') };
    }) });
    content = turndown.turndown(DOMPurify.sanitize(result.value, { USE_PROFILES: { html: true } }));
    warnings.push(...result.messages.map(message => message.message));
  } else if (/\.(md|markdown|txt)$/i.test(file.name)) content = await file.text();
  else throw new Error('請選擇 Markdown、Word .docx 或 .txt 檔案');
  content = content.replace(/\r\n?/g, '\n');
  if (textBytes(content) > MAX_CONTENT_BYTES) throw new Error('轉換後內容超過 50 MB；Word 圖片轉換後可能比原檔大，請減少圖片或拆分文件');
  return { title: content.match(/^#\s+(.+)$/m)?.[1]?.trim().slice(0, 160) || file.name.replace(/\.[^.]+$/, '').slice(0, 160), category: '匯入筆記', tags: [/\.docx$/i.test(file.name) ? 'Word' : 'Markdown'], content, warnings };
}
